import React from 'react';
import Avatar from '@concur/nui-widgets/Avatar';
import initials from 'initials';
import initialsSupported from '../utils/initialsSupported';

const UserAvatar = ({
    formatter,
    lang,
    employeeDisplayName,
    className,
    size,
    isOpusUser,
    isCompleteTheme,
}) => {
    if (initialsSupported(lang)) {
        const avatarInitials = typeof employeeDisplayName === 'string'
            ? initials.parse(employeeDisplayName).initials
            : undefined;

        if (avatarInitials) {
            return (
                <Avatar
                    className={className}
                    ariaLabel={formatter.formattedMessage({ id: 'CoreUI.profile.profile' })}
                    accentColor={isOpusUser && isCompleteTheme ? 3 : 6}
                    data-test="user-icon-avatar-shellbar"
                    iconName="user"
                    size={size}
                >
                    {avatarInitials}
                </Avatar>
            );
        }
    }

    return (
        <Avatar
            className={className}
            ariaLabel={formatter.formattedMessage({ id: 'CoreUI.profile.profile' })}
            accentColor={6}
            data-test="user-icon-avatar-shellbar"
            iconName="user"
            size={size}
        />
    );
};

UserAvatar.displayName = 'UserAvatar';

export default UserAvatar;
